// assets/unit-price.js
(() => {
  if (Shopify.designMode) {
    return;
  }

  const fmt = Shopify.formatMoney || (c => '$' + (c/100).toFixed(2));

  const initPriceUpdater = () => {
    const packPriceEl = document.getElementById('pack-price');
    const unitPriceEl = document.getElementById('unit-price');

    if (!packPriceEl || !unitPriceEl) return;

    document.addEventListener('variant:changed', (e) => {
      const variant = e.detail.variant;
      
      if (!variant) return;

      let qty = 1;
      
      // This logic mirrors your Liquid snippet: it assumes quantity is the second variant option.
      if (variant.options && variant.options.length > 1) {
          const qtyValue = variant.options[1]; // Get the second option, e.g., "25"
          const match = String(qtyValue).match(/\d+/); // Extract the number
          if (match) {
            qty = parseInt(match[0], 10);
          }
      }
      
      // Failsafe in case quantity is 0
      if (qty === 0) {
        qty = 1;
      }
      
      // Update the total price
      packPriceEl.textContent = fmt(variant.price);
      
      // Calculate and update the price per card
      unitPriceEl.textContent = fmt(Math.round(variant.price / qty));
    });
  };

  document.addEventListener('DOMContentLoaded', initPriceUpdater);
})();